import styled from 'styled-components'
import { ChipItem } from '../../_styles'
import PackageTypeBadge from 'components/Common/PackageTypeBadge'

const Wrapper = styled(ChipItem)`
  display: flex;
  flex-direction: row;
  gap: 8px;
`

const SizeValue = styled.div`
  font: var(--typography-14-16-semibold);
  color: var(--color-sw-60);
`

const BottleItem = ({ active, size, href, packageType }) => {
  return (
    <Wrapper to={href} selected={active}>
      <SizeValue>{size}</SizeValue>
      <PackageTypeBadge value={packageType} />
    </Wrapper>
  )
}

export default BottleItem
